<template>
    <div class="custom-settings-popover column-settings-wrapper">
        <div class="column-settings">
            <div class="settings-close" @click="hideColumnSettings">
                ×
            </div>
            <v-bar wrapper="v-bar-col-settings">
                <div class="subtitle">
                    выводить данные:
                </div>
                <el-form>
                    <el-checkbox-group class="dialog-checkbox-group" v-model="columns">
                        <el-checkbox
                            :class="['dialog-checkbox', { hide: column.colId === '0' }]"
                            size="medium"
                            name="columns"
                            v-for="column in displayedColumns"
                            :label="column.colId"
                            :key="column.colId"
                        >
                            {{ (column.name || defaultColumnName(column.colId)) | uppercase }}
                        </el-checkbox>
                    </el-checkbox-group>
                    <div class="actions-wrapper">
                        <div class="btn btn-default grey" @click="hideColumnSettings">
                            отменить
                        </div>
                        <div class="btn btn-default orange" @click="setSelectedColumns(columnsModel)">
                            применить
                        </div>
                    </div>
                </el-form>
            </v-bar>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus';
import { toMobileColumnId } from '@/common/columns';
import localReferences from '@/helpers/localReferences';
import VBar from 'v-bar';

//человекочитаемые названия для колонок, у которых не задано имя в настройках
const defaultColumnNames = {
    'id': 'ID',
    'name': 'Имя',
    'unread_messages': 'Непрочтённые сообщения',
    'created_at': 'Дата создания',
    'tags': 'Теги',
    'status': 'Статус',
    'status.id': 'Статус',
    'status.name': 'Статус',
    'status_id': 'Статус',
    'pipeline_id': 'Воронка',
    'responsible_user': 'Ответственный',
    'responsible_user.full_name': 'Ответственный',
    'responsible_user_id': 'Ответственный',
    'office': 'Офис',
    'office.id': 'Офис',
    'office.name': 'Офис',
    'office_id': 'Офис',
    'contact_name': 'Контакт',
    'ltv_type': 'Тип LTV',
    'ltv_certificate_number': 'Сертификат LTV №',
    'referral_full_name': 'ФИО рекомендателя',
    'referral_phone': 'Телефон рекомендателя',
    'nps_manager': 'Менеджер NPS',
    'nps_manager_id': 'Менеджер NPS',
    'contact.name': 'Имя контакта',
    'contact.id': 'Контакт',
    'contact.phone': 'Телефон контакта',
    'contact.email': 'E-mail контакта',
    'contact_id': 'Контакт',
    'contact_phone': 'Телефон',
    'contact_email': 'E-mail',
    'contact_phones': 'Телефоны',
    'contact_address': 'Адрес',
    'address': 'Адрес',
    'title': 'Название',
    'company_name': 'Компания',
    'company_id': 'Компания',
    'contract_number': 'Номер договора',
    'contract_date': 'Дата договора',
    'budget': 'Бюджет',
    'link': 'Канал связи',
    'link.name': 'Канал связи',
    'link.id': 'Канал связи',
    'link_id': 'Канал связи',
    'volume': 'Объём',
    'square_m2': 'Площадь',
    'finish': 'Отделка',
    'profile_type': 'Тип профиля',
    'profile_type_id': 'Тип профиля',
    'jalousie': 'Жалюзи',
    'promising_customer': 'Перспективный клиент',
    'measurement_date': 'Дата замера',
    'measurer_user': 'Замерщик',
    'measurer_user_id': 'Замерщик',
    'difficult_metering': 'Сложный замер',
    'measurer_bonus': 'Бонус замерщика',
    'conclusion': 'Заключение',
    'conclusion_id': 'Заключение',
    'start_production_date': 'Дата производства',
    'discount': 'Скидка',
    'prepay': 'Предоплата',
    'pay_type': 'Тип оплаты',
    'pay_type_id': 'Тип оплаты',
    'installer_balance': 'Баланс установщика',
    'delivery_balance': 'Баланс доставки',
    'in_production': 'В производстве',
    'in_production_id': 'В производстве',
    'production_cost': 'Себестоимость',
    'jalousie_cost': 'Стоимость жалюзи',
    'finish_cost': 'Стоимость отделки',
    'garbage_removal': 'Вынос мусора',
    'garbage_removal_id': 'Вынос мусора',
    'delivery_date': 'Дата доставки',
    'installation_date': 'Дата монтажа',
    'installation_user': 'Монтажник',
    'installation_user_id': 'Монтажник',
    'installers_salary': 'ЗП монтажников',
    'installers_debt': 'Долг монтажников',
    'additional_work': 'Доп. работы',
    'complaint_opening_date': 'Дата открытия рекламации',
    'complaint_amount': 'Сумма рекламации',
    'complaint_materials_cost': 'Стоимость материалов',
    'guilty': 'Виновный',
    'guilty_id': 'Виновный',
    'complaint_performer': 'Исполнитель рекламации',
    'complaint_performer_id': 'Исполнитель рекламации',
    'specialist_payment': 'Оплата специалиста',
    'complaint_closing_date': 'Дата закрытия рекламации',
    'roistat': 'Roistat',
    'culprit': 'Виновник',
    'culprit_id': 'Виновник',
    'measurement_time': 'Время замера',
    'to_production': 'В производство',
    'refuse_before_metering': 'Отказ до замера',
    'tech_refusal': 'Тех. отказ',
    're_measurement': 'Перезамер',
    're_measurement_date': 'Дата перезамера',
    're_measurement_time': 'Время перезамера',
    'finish_amount': 'Сумма отделки',
    'jalousie_amount': 'Сумма жалюзи',
    'installation_done': 'Монтаж выполнен',
    'custom_fields': 'Доп. поля',
    'value': 'Целевой лид',
    'email': 'E-mail',
    'birthday': 'День рождения',
    '0': 'Иконка настроек'
};

export default {
    name: 'ColumnSettingsMobile',
    data() {
        return {
            columns: []
        };
    },
    components: { VBar },
    props: {
        attributes: {
            type: Object,
            default: () => {}
        },
        columnsModel: {
            type: Array,
            default: () => {}
        }
    },
    computed: {
        displayedColumns() {
            const showLtv = localReferences.isLtvPipeline(this.$route.query.pipeline_id);
            return (this.columnsModel || []).filter(column => {
                if (localReferences.ltvColumnIds.indexOf(column.colId) !== -1 && !showLtv) {
                    return false;
                }
                return true;
            });
        }
    },
    methods: {
        defaultColumnName(colId) {
            return defaultColumnNames[colId] || colId;
        },
        hideColumnSettings() {
            eventBus.$emit('hideColumnSettings');
        },
        //имена чекбоксов
        setColNames(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = toMobileColumnId(item.colId);
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName)) {
                    this.$set(item, 'name', this.attributes[colName].name);
                }
            });
        },
        //активные(видимые) столбцы иниц.
        getActiveColumns(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = toMobileColumnId(item.colId);
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName) && !this.attributes[colName].hide) {
                    this.columns.push(item.colId);
                }
            });
        },
        //фиксируем выбранные/невыбранные столбцы(клик по кнопке применить)
        setSelectedColumns(settings) {
            settings.forEach((item) => {
                if (this.columns.includes(item.colId)) {
                    item.hide = false;
                } else {
                    if (item.hide === false) {
                        item.hide = true;
                    }
                }
                //иконка настроек для десктоп
                if (item.colId === '0') {
                    item.hide = false;
                }
                this.$delete(item, 'name');
            });
            eventBus.$emit('newColumnSettings', this.columnsModel);
            this.hideColumnSettings();
        }
    },
    mounted() {
        this.setColNames(this.columnsModel);
        this.getActiveColumns(this.columnsModel);
    },
    filters: {
        uppercase: function(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
};
</script>
